import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Balance } from './.'
import TotalizersPlaceholder from './TotalizersPlaceholder'
import { ToggleFeature, features } from 'features/ToggleFeature'

const className = 'extract-resume row bg-ui-5 border-bottom border-color-ui-3'

class Totalizers extends Component {
  componentDidMount () {
    this.props.fetchExtractTotalizer()
  }

  render () {
    if (this.props.totalizers.isLoading || this.props.balance.isLoading) {
      return <TotalizersPlaceholder />
    }

    return (
      <div className={className}>
        <Balance {...this.props} />
        <ToggleFeature feature={features.HistoryExtract} {...this.props} />
      </div>
    )
  }
}

Totalizers.propTypes = {
  fetchExtractTotalizer: PropTypes.func.isRequired,
  totalizers: PropTypes.shape({ isLoading: PropTypes.bool.isRequired })
    .isRequired,
  balance: PropTypes.shape({ isLoading: PropTypes.bool.isRequired }).isRequired
}

export default Totalizers



// WEBPACK FOOTER //
// ./src/Participant/Extract/Totalizers/Totalizers.js